import { createUpserter } from '@/app/shared/utils'
import { AddQuestionAttemptsTrackingCommand } from '../api';
import { QuestionAttemptsTrackingState,
         defaultQuestionAttemptsTrackingState } from './question-attempts-tracking-state'

type Collection = QuestionAttemptsTrackingState[];
export type QuestionAttemptCommand = AddQuestionAttemptsTrackingCommand;

const upsert = createUpserter<QuestionAttemptsTrackingState, QuestionAttemptsTrackingState> (
  (id) => defaultQuestionAttemptsTrackingState(id));

export function questionAttemptReducer(state: Collection, command: QuestionAttemptCommand) {
  switch (command.name) {
    case 'add-question-attempts':
      const questions = command.payload;
      for (let question of questions) {
        state = upsert(state, question.id, (item) => {
          const newState: QuestionAttemptsTrackingState = {
            id: item.id,
            attempts: [
              ...item.attempts,
              ...question.attempts
            ]
          }
          return newState
        })
      }

      return state
  }
}
